/* @flow */

import * as React from 'react';

import ChevronIcon from './ChevronIcon';

import type { Props } from './ChevronIcon';

const ChevronIconDown = (props: Props): React.Node => (
  <ChevronIcon {...props} down />
);

export default React.memo<Props>(ChevronIconDown);
